import AbstractInterieur from "./AbstractInterieur.js";

export default class Konstruktionsboden extends  AbstractInterieur{
    constructor(vsData) {
        super(vsData);
        this.tapable = true;
    }

    onDragBegin() {
        super.onDragBegin();
        APP.model.showDoorsClosed(false);
    }


}